import React from 'react';

import { Control, FieldValues, Path, RegisterOptions, useController } from 'react-hook-form';

import { TextField } from '@mui/material';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  rules?: RegisterOptions<T>;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
};

// React Hook Form wrapper around MUI TextField with type="datetime-local".
// Use alongside Input and Select from this folder. For date-only fields, use DateWidget instead.
export default function DateTimeInput<T extends FieldValues>({
  control,
  name,
  label,
  rules,
  fullWidth,
  required,
  disabled,
}: Props<T>) {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules });

  return (
    <TextField
      {...field}
      label={label}
      type="datetime-local"
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
      error={!!error}
      helperText={error?.message}
      slotProps={{ inputLabel: { shrink: true } }}
    />
  );
}
